<!-- This is receving the note -->
<div class="p-3">
    <p class="text-muted pt-2 pl-2 pb-0">Note at: <span>{{data.video_timestamp}}</span></p>
    <!-- The input -->
    <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Make Note</mat-label>
        <input matInput placeholder="I'm making note" [(ngModel)]="note">
        <mat-icon matSuffix>notes</mat-icon>
    </mat-form-field>
    <div class="row mx-auto justify-content-end m-2">
        <button mat-raised-button mat-dialog-close>Close</button>
        <button mat-raised-button class="btn-primary ml-3" (click)="addResourceNote()">Save</button>
    </div>
</div>